import { useEffect, useState } from "react";

export const useOnScreen = (ref: React.RefObject<HTMLDivElement | null>, flag: boolean = false) => {
    const [isIntersecting, setIntersecting] = useState(false);
    
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
              setIntersecting(entry.isIntersecting)
            },
            {
                rootMargin: '500px'
            }
        );

        const target = ref.current;
        if (target && !flag && !isIntersecting) {
           observer.observe(target);
        } else if (target && isIntersecting) {
            observer.unobserve(target);
        }

        let timeout: NodeJS.Timeout;

        if (target && !flag && !isIntersecting) {
            const tTop = target.getBoundingClientRect().top;
            
            timeout = setTimeout(() => {
                setIntersecting(true);
            }, ((tTop * 2) + 5000));
        }

      return () => {
        if (target) {
          observer.unobserve(target);
        }

        if (timeout) {
            clearTimeout(timeout);
        }
      }
    }, [ref, flag, isIntersecting])

    return isIntersecting || flag;
}